import React from 'react'
import './footer.css'
import { FaFacebookF } from 'react-icons/fa'
import { GrInstagram } from 'react-icons/gr'
import { AiFillGithub } from 'react-icons/ai'

export default function Footer() {
  return (
    <footer>
      <a href='#' className='footer_logo'>
        Masy design
      </a>

      <ul className='permalinks'>
        <li>
          <a href='#'>Acceuil</a>
        </li>
        <li>
          <a href='#about'>A propos</a>
        </li>
        <li>
          <a href='#experiences'>Experiences</a>
        </li>
        <li>
          <a href='#services'>Services</a>
        </li>
        <li>
          <a href='#portofolio'>Portofolio</a>
        </li>
        <li>
          <a href='#testimonials'>Temoignages</a>
        </li>
        <li>
          <a href='#contact'>Contact</a>
        </li>
      </ul>

      <div className='footer_socials'>
        <a href=''>
          <FaFacebookF></FaFacebookF>
        </a>
        <a href=''>
          <GrInstagram></GrInstagram>
        </a>
        <a href=''>
          <AiFillGithub></AiFillGithub>
        </a>
      </div>
      <div className='footer_copyright'>
        <small>&copy; @masy design (SYLLA Mangué). All rights reserved.</small>
      </div>
    </footer>
  )
}
